module.exports = __webpack_public_path__ + "img/aiSubtitled.285722e9.svg";